import React, { ComponentClass, FunctionComponent } from "react";
import appPath from "utils/appPath";
import styles from "./styles.module.scss";

export default function ScreenContainer(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    Component: FunctionComponent<any> | ComponentClass,
    { hasMultipleScreens }: { hasMultipleScreens?: boolean } = {}
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
): (props: Record<string, any>) => JSX.Element {
    /* eslint-disable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */
    return (props): JSX.Element => {
        const className = hasMultipleScreens || appPath.isIframePath()
            ? ""
            : styles.container;

        return (
            <main className={ className }>
                <Component { ...props } />
            </main>
        );
    };
}
